import { Button } from '@/components/ui/button';
import { Edit, Eye } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { Risk } from '@/types/risks';
import { useNavigate } from 'react-router-dom';
import { routePathByName } from '../../../routes';
import { cleanDateAndTimeObject, toLocalDateString } from '@shared/renderDate'

import HelpPopoverHover from '@/components/HelpPopoverHover';

export const getRiskColumns = (
  navigate: ReturnType<typeof useNavigate>,
  onActions: { onEdit: () => void; onView: () => void },
  helpData?: any,
  basePath: string = '/risk-detail'
): ColumnDef<Risk, any>[] => [
  { // <UserAssistance path="riskregister.table.id" />
    header: () => {
      return (
        <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
          <HelpPopoverHover config={helpData?.['table.header.id']}>ID</HelpPopoverHover>
        </span>
      )
    },//<span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">ID<FontAwesomeIcon icon={faCircleQuestion} /></span>,
    accessorKey: 'id',
    cell: ({ getValue }) => <span className="font-medium text-center w-full block">{getValue()}</span>,
  },
  {
    header: () => {
      return (
        <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
          <HelpPopoverHover config={helpData?.['table.header.businessunit']}>Business Unit</HelpPopoverHover>
        </span>
      )
    }, //<span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">Business Unit<FontAwesomeIcon icon={faCircleQuestion} /></span>,
    accessorKey: 'category',
    cell: ({ getValue }) => <span className="text-center w-full block">{getValue()}</span>,
  },
  {
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block whitespace-normal break-words">
        <HelpPopoverHover config={helpData?.['table.header.risk']}>Risk</HelpPopoverHover>
      </span>
    ),
    accessorKey: 'risk',
    cell: ({ getValue }) => <span className="text-center w-full block whitespace-normal break-words" style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>{getValue()}</span>,
  },
  {
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
        <HelpPopoverHover config={helpData?.['table.header.riskrating']}>Residual Risk</HelpPopoverHover>
      </span>
    ),
    accessorKey: 'residualRisk',
    cell: ({ getValue }) => <div className="text-center w-full"><Badge variant={getValue().toLowerCase()}>{getValue()}</Badge></div>,
  },
  {
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
        <HelpPopoverHover config={helpData?.['table.header.linkedassets']}>Linked Assets</HelpPopoverHover>
      </span>
    ),
    accessorKey: 'assets',
    cell: ({ row }) => {
      const assets = Array.isArray((row.original as any).assets)
        ? (row.original as any).assets
        : [];
      const count = assets.length;
      return (
        <span className="text-center w-full block">
          {count === 0 ? 'None' : `${count} linked`}
        </span>
      );
    },
  },
  {
    header: () => {
      return (
        <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
          <HelpPopoverHover config={helpData?.['table.header.response']}>Response</HelpPopoverHover>
        </span>
      )
    }, //<span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">Response<FontAwesomeIcon icon={faCircleQuestion} /></span>,
    accessorKey: 'response',
    cell: ({ row }) => <span className="text-center w-full block">{row.original.response || ''}</span>,
  },
  {
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
        <HelpPopoverHover config={helpData?.['table.header.nextreviewdate']}>Next Review Date</HelpPopoverHover>
      </span>
    ),
    accessorKey: 'nextReviewDate',
    cell: ({ getValue }) => {
      const date = toLocalDateString(cleanDateAndTimeObject(getValue())) || '';
      return <span className="text-center w-full block">{date}</span>
    },
  },
  {
    header: () => (
      <span className="bg-transparent px-2 py-1 rounded font-semibold text-center w-full block">
        <HelpPopoverHover config={helpData?.['table.header.actions']}>Actions</HelpPopoverHover>
      </span>
    ),
    id: 'actions',
    cell: ({ row }) => (
      <div className="flex gap-1 justify-center">
        {/* <Button variant="ghost" size="icon" onClick={() => onActions.onEdit?.(row.original)}>
          <Edit className="h-4 w-4" />
        </Button> */}
        <Button variant="ghost" size="icon" onClick={() => {
          if (basePath !== '/risk-detail') {
            navigate(`${basePath}/${row.original.riskID}`);
          } else {
            navigate(routePathByName('risk.detail', { id: row.original.riskID }));
          }
        }}>
          <Eye className="h-4 w-4" />
        </Button>
      </div>
    ),
    enableSorting: false,
  },
];
